export const requestNotificationPermission = async () => {
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        navigator.serviceWorker.register('/sw.js').catch((registrationError) => {
          console.error('Service worker registration failed:', registrationError)
        })
      }
    })
  }
}

export const pushNotification = (message: string) => {
  if (Notification.permission !== 'granted') return

  if (message && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.active?.postMessage({
        type: 'SHOW_NOTIFICATION',
        title: 'Tracker Boot',
        message,
      })
    })
  }
}

export const showBadge = (count: number) => {
  try {
    if ('setAppBadge' in navigator) {
      if (count > 0) {
        navigator.setAppBadge(count)
      } else if ('clearAppBadge' in navigator) {
        navigator.clearAppBadge()
      }
    }
  } catch (e) {}
}
